import { CustomListItemStyleItem } from './CustomListItemStyleItem'

export const Multiple = new CustomListItemStyleItem({
  id: '0AB8790C-2FAC-42E9-84CB-F68C4061C665',
  name: 'Multiple',
  label: 'Multiple - a dropdown where multiple items can be selected',
  help: 'a dropdown where multiple items can be selected',
})
export const Single = new CustomListItemStyleItem({
  id: '19F01FAB-2BFC-4075-B3BF-2F40D5FCF1F9',
  label: 'Single - a dropdown where only a single item can be selected',
  help: 'a dropdown where only a single item can be selected',
  name: 'Single',
})
export const Checkboxes = new CustomListItemStyleItem({
  id: '5B4050CC-DD6F-4CE7-967D-E5F41B58A208',
  label: 'Checkboxes - all items behave as checkboxes',
  help: 'all items behave as checkboxes',
  name: 'Checkboxes',
})
